<script>
	import Axios from 'axios'
	import { mapGetters } from 'vuex'
	import AOS from 'aos'
	import 'aos/dist/aos.css'
	import _system from '../../../libs/system'
	export default 
	{
		name: 'UpgradePlan',
		data(){
			return {
				loader: false
			}
		},
        computed: 
	    {
      ...mapGetters('session', ['isLoggedIn'])
		},
		created(){
			AOS.init(); 
		},
		mounted(){
		}
	}
</script>

<template>
<span style="margin: -1rem;">
<iframe src="https://juphy.com/pricing" width="100%" height="100%" frameborder="0"></iframe>
</span>
</template>

<style>

</style>




// WEBPACK FOOTER //
// src/components/dashboard/communityBoard/upgradePlan.vue